<div class="container">
  <div *ngFor="let vehicle of vehicles">
    <app-vovehicle [vehicle]="vehicle" [isFormOpen]="isFormOpen" (editClicked)="openFormWithVehicle($event)" (delClicked)="onDeleteVehicle()">
    </app-vovehicle>
  </div>
</div>

<app-voform [vehicle]="vehicle" [isFormOpen]="isFormOpen" (closeClicked)="onFormClosed($event)" (updateVehicle)="onUpdateVehicle()"></app-voform>
